<template>
    <div class="account-page">
        <div class="main-wrapper">
            <div class="account-content">
                <div class="login-wrapper">
                    <div class="login-content">
                        <div v-if="isForcedChange||isAuthenticated" class="login-userset">
                            <div class="login-logo logo-normal">
                                <img src="../../../assets/img/logo.png" alt="Logo" />
                            </div>
                            <div class="login-userheading">
                                <h3>{{ isForcedChange ? 'Mandatory Password Update' : 'Change Password' }}</h3>
                                <h4>
                                    {{ isForcedChange ? 'You must set a new password to continue.' : 'Update your existing credentials.' }}
                                </h4>
                            </div>

                            <form class="login" @submit.prevent="handleChangePassword">
                                
                                <div class="form-login">
                                    <label>Email Address</label>
                                    <div class="form-addons">
                                        <input type="email" v-model="email" disabled required class="form-control" />
                                        <img src="../../../assets/img/icons/mail.svg" alt="img" />
                                    </div>
                                </div>

                                <div class="form-login">
                                    <label>New Password</label>
                                    <div class="pass-group">
                                        <input 
                                            :type="newPasswordType" 
                                            v-model="newPassword" 
                                            placeholder="Enter New Password"
                                            required 
                                            class="form-control pass-input"
                                        />
                                        <span @click="toggleNewPassword" class="fas toggle-password"
                                            :class="{ 'fa-eye': showNewPassword, 'fa-eye-slash': !showNewPassword }">
                                        </span>
                                    </div>
                                </div>
                                
                                <div class="form-login">
                                    <label>Confirm New Password</label>
                                    <div class="pass-group">
                                        <input 
                                            type="password" 
                                            v-model="confirmNewPassword" 
                                            placeholder="Confirm New Password"
                                            required 
                                            class="form-control pass-input"
                                        />
                                    </div>
                                </div>
                                
                                <div v-if="statusMessage" :class="['alert', isError ? 'alert-danger' : 'alert-success', 'mt-3']">
                                    {{ statusMessage }}
                                </div>

                                <div class="form-login">
                                    <button class="btn btn-login" type="submit" :disabled="isLoading || !canSubmit">
                                        {{ isLoading ? 'Processing...' : 'Change Password' }}
                                    </button>
                                </div>
                                
                                <div class="form-login text-center">
                                    <router-link v-if="!isForcedChange" to="/index" class="hover-a">
                                        Cancel
                                    </router-link>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="login-img">
                        <img src="../../../assets/img/login.jpg" alt="img" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';

export default {
    name: 'AuthPasswordUpdate',
    data() {
        return {
            email: this.$route.query.email || '', // Pre-fill from query (forced change) or Vuex
            newPassword: '',
            confirmNewPassword: '',
            showNewPassword: false,

            isLoading: false,
            statusMessage: null,
            isError: false,
        };
    },
    computed: {
        ...mapGetters(['isAuthenticated', 'getUserDetails']),
        
        isForcedChange() {
            return !!this.$route.query.email;
        },
        newPasswordType() {
            return this.showNewPassword ? 'text' : 'password';
        },
        canSubmit() {
            return  this.newPassword === this.confirmNewPassword;
        }
    },
    watch: {
        isAuthenticated: {
            immediate: true,
            handler(isAuth) {
                if (!isAuth && !this.isForcedChange) {
                // Perform the redirection
                this.$router.push('/signin');
            }
                else if (isAuth && !this.isForcedChange) {
                    this.email = this.getUserDetails? this.getUserDetails[3]?.Value : '';
                }
                
            }
        },
        getUserDetails: {
        immediate: true,
        handler(details) {
            if (!this.$route.query.email && this.getUserDetails && this.getUserDetails[3].Value) {
                    this.$data.email = this.getUserDetails[3].Value;
                }
        }
    },
        
    },
    methods: {
        ...mapActions(['logout']),
        toggleNewPassword() {
            this.showNewPassword = !this.showNewPassword;
        },

        async handleChangePassword() {
            this.statusMessage = null;
            this.isError = false;
            
            if (this.newPassword !== this.confirmNewPassword) {
                this.statusMessage = 'New passwords do not match.';
                this.isError = true;
                return;
            }
            if (this.newPassword.length < 6) {
                this.statusMessage = 'New password must be at least 6 characters.';
                this.isError = true;
                return;
            }

            this.isLoading = true;

            try {
                const payload = {
                    email: this.email,
                    new_password: this.newPassword,
                };

                const response = await axios.post('/v1/auth/change-password', payload);
                
                if (response.data.status === 'SUCCESS') {
                    this.statusMessage = response.data.message || 'Password updated successfully! Please sign in with your new password.';
                    this.isError = false;
                    
                    await this.logout();
                    
                    setTimeout(() => {
                        this.$router.push({ 
                        name: 'signin', 
                        query: { email: this.email } 
                    });
                    }, 1000);
                }

            } catch (err) {
                console.log(err)
                const responseData = err.response?.data.detail || err.response?.data;
                this.isError = true;
                this.newPassword = '';
                this.confirmNewPassword = '';
                
                this.statusMessage = responseData?.message 
                                    || 'Invalid credentials or an unexpected error occurred.';

            } finally {
                this.isLoading = false;
            }
        },
    },
    created() {
        if (!this.isAuthenticated && !this.isForcedChange) {
            this.$router.push({ name: 'signin' });
        }
    }
};
</script>

<style scoped>
/* Simplified CSS for messages */
.pass-group {
    position: relative;
}
.toggle-password {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 10;
}
.alert {
    padding: 10px;
    border-radius: 4px;
    font-size: 14px;
    text-align: center;
}
.alert-danger {
    background-color: #f8d7da;
    color: #721c24;
}
.alert-success {
    background-color: #d4edda;
    color: #155724;
}
</style>